<template>
  <div
    class="mt-2 px-3 py-2.5 border border-secondary rounded-lg text-secondary shadow-sm"
    :class="[point === 'left' ? 'rounded-tl-none' : 'rounded-tr-none']"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  point: {
    type: String,
    default: 'left'
  }
})
</script>

<style></style>
